import { ThemeComponent } from "@/theme/ThemeComponent";
import { OptionSelector } from "@/utils/OptionSelectors";
import { Component, Prop, Ref, SimpleEvent } from "@eastsideco/salvo-ts";
import { ProductOption } from "./ProductOptionPicker";

@Component
export class ProductRadioOption extends ThemeComponent implements ProductOption {
    @Prop name!: string;
    @Prop values!: string[];
    @Prop selected!: string|null;
    @Prop position!: number;
    @Prop emptyOption!: boolean;

    @Ref input!: HTMLInputElement[];
    @Ref radioLabel!: HTMLElement[];

    private valuesWithoutStock: string[] = [];
    private valuesWithoutVariant: string[] = [];

    private _onChange = new SimpleEvent<string|null>();
    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        for(const label of this.radioLabel) {
            this.$listen(label, 'click', (e) => {
                this.valueChanged(label);
            });
        }
    }

    private valueChanged(label: HTMLElement) {
        for(const label of this.radioLabel) {
            label.classList.remove('radio-selection--checked');
        }
        label.classList.add('radio-selection--checked');
        const selectedInput = label.querySelector('input') as HTMLInputElement;
        if (selectedInput) {
            selectedInput?.checked;
            this.selected = selectedInput?.value || null;
        }
        // const continueSelling = selectedInput.getAttribute('data-continue-selling') == 'continue';
        // const quantity = Number(selectedInput.getAttribute('data-quantity'));

        // this.handleAddToCartButton(continueSelling, quantity);

        this._onChange.dispatch(this.selected);
    }


    // private handleAddToCartButton(continueSelling: boolean, quantity: number) {
    //     const addToCartButtons =
    //         document.querySelectorAll('[data-ref="singleProductSubmitButton"]') as NodeListOf<HTMLButtonElement>;

    //     // for( const button of addToCartButtons) {
    //     //     const action = continueSelling && quantity <= 0 ? 'remove' : 'add';
    //     //     button.classList[action]('button--disabled');
    //     //     button.disabled = !(continueSelling && quantity <= 0);
    //     // }
    // }

    public select(value: string|null) {
        // this.selected = this.input.value;
        // this.input.value = value || '';
    }

    public updateBasedOnSelector(selector: OptionSelector) {
        this.valuesWithoutStock = selector.options[this.position - 1].values
            .filter((v) => v.outOfStock).map((v) => v.value);
        this.valuesWithoutVariant = selector.options[this.position - 1].values
            .filter((v) => !v.variantExists).map((v) => v.value);

        // this.updateOptionLabels();
    }

    // private updateOptionLabels() {
    //     for (const optionEl of this.input.options) {
    //         optionEl.label = optionEl.value;
    //         if (this.valuesWithoutStock.indexOf(optionEl.value) > -1){
    //             optionEl.label += ' - Out of stock';
    //         } else if (this.valuesWithoutVariant.indexOf(optionEl.value) > -1) {
    //             optionEl.label += ' - Not available';
    //         }
    //     }
    // }
}
